<!--
 * @Author: chencong
 * @Date: 2020-09-8 11:15:30
 * @LastEditTime: 2021-01-30 17:26:07
 * @LastEditors: ShiWeiShan
 * @Description: 水量复核申请
 * @FilePath: \fs-js-pcweb-user\src\components\applyForm\billRecheckForm.vue
-->
<template>
  <div class="bill-recheck container">
    <div class="add-form">
      <div class="add-body">
        <div class="add-table">
          <h2 class="table-title">附件5：佛山市非居民用水超计划（超定额）水量复核申请表</h2>
          <table class="common-form-table form-table-1">
            <tr class="table-row">
              <td class="column_1 td-label" colspan="1">复核的待收费记录：</td>
              <td class="column_2" colspan="1">
                {{ billName }}
              </td>
            </tr>
          </table>
          <table class="common-form-table form-table-1">
            <tr class="table-row">
              <td class="column_1 td-label" colspan="1">受理号（此栏由受理单位填写）：</td>
              <td class="column_2" colspan="1">
                <el-input
                  v-model="formData['code']"
                  size="mini"
                  clearable
                  :disabled="true"
                  :title="formData['code']"
                  @input="formDataChange('code')"
                ></el-input>
              </td>
            </tr>
          </table>
          <table class="common-form-table form-table-2">
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="5">以下栏目由非居民用水户填写</td>
            </tr>

            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">单位名称</td>
              <td class="column_2" colspan="4">
                <el-input
                  v-model="formData['user_name']"
                  size="mini"
                  clearable
                  :disabled="true || !editStatus || valueDisabled['user_name']"
                  :title="formData['user_name']"
                  @input="formDataChange('user_name')"
                ></el-input>
              </td>
            </tr>

            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">联系人</td>
              <td class="column_2" colspan="1">
                <el-input
                  v-model="formData['contact_man']"
                  size="mini"
                  clearable
                  :disabled="true || !editStatus || valueDisabled['contact_man']"
                  :title="formData['contact_man']"
                  @input="formDataChange('contact_man')"
                ></el-input>
              </td>
              <td class="column_3 text-center td-label" colspan="1">联系电话</td>
              <td class="column_4" colspan="2">
                <el-input
                  v-model="formData['contact_phone']"
                  size="mini"
                  clearable
                  :disabled="true || !editStatus || valueDisabled['contact_phone']"
                  :title="formData['contact_phone']"
                  @input="formDataChange('contact_phone')"
                ></el-input>
              </td>
            </tr>

            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">单位地址</td>
              <td class="column_2" colspan="4">
                <el-input
                  v-model="formData['addr_detail']"
                  size="mini"
                  clearable
                  :disabled="true || !editStatus || valueDisabled['addr_detail']"
                  :title="formData['addr_detail']"
                  @input="formDataChange('addr_detail')"
                  placeholder="xx 镇（街） xx 号"
                ></el-input>
              </td>
            </tr>

            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">用水户号</td>
              <td class="column_2" colspan="4">
                <el-input
                  v-model="formData['meter_code_list']"
                  size="mini"
                  clearable
                  :disabled="true || !editStatus || valueDisabled['meter_code_list']"
                  :title="formData['meter_code_list']"
                  @input="formDataChange('meter_code_list')"
                ></el-input>
              </td>
            </tr>

            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">用水性质</td>
              <td class="column_2" colspan="4">
                <select-water-nature
                  v-model="formData['usewater_id']"
                  :disabled="true || !editStatus || valueDisabled['usewater_id']"
                  @change="formDataChange('usewater_id')">
                </select-water-nature>
              </td>
            </tr>
          </table>
          <table class="common-form-table form-table-3">
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="7">水量复核相关</td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">建议复核月份</td>
              <td class="column_2" colspan="6">
                <el-date-picker
                  v-model="formData['recheck_month']"
                  size="mini"
                  type="monthrange"
                  placeholder="选择日期"
                  :disabled="!editStatus || valueDisabled['recheck_month']"
                  value-format="yyyy-MM"
                  @change="formDataChange('recheck_month')"
                ></el-date-picker>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">复核理由</td>
              <td class="column_2" colspan="6">
                <el-select
                  v-model="formData['recheck_reason']"
                  placeholder="请选择"
                  clearable
                  @change="formDataChange('recheck_reason')"
                  :disabled="!editStatus || valueDisabled['recheck_reason']"
                  :title="F_getOptionLabel(dictLabelValues['UsewaterRecheckReason']|| [], formData['adjust_reason'])"
                  size="mini"
                >
                  <el-option
                    v-for="value in (dictLabelValues['UsewaterRecheckReason'] || [])"
                    :key="value.value"
                    :label="value.label"
                    :value="value.value"
                  ></el-option>
                </el-select>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">计划用水量复核理由及说明（可另附页说明）</td>
              <td class="column_2 text-center" colspan="6">
                <el-input
                  v-model="formData['recheck_statement']"
                  size="mini"
                  type="textarea"
                  clearable
                  :disabled="!editStatus || valueDisabled['recheck_statement']"
                  :title="formData['recheck_statement']"
                  @input="formDataChange('recheck_statement')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">附件清单</td>
              <td class="column_2" colspan="6">
                1.单位（企业）基本情况：<common-upload
                  v-model="formData['file_1']"
                  :disabled="!editStatus || valueDisabled['file_1']"
                  fileAccept="image/jpeg,application/pdf"
                  @change="formDataChange('file_1')">
                </common-upload>
                2.供水企业开具的水量和水费清单：<common-upload
                  v-model="formData['file_2']"
                  :disabled="!editStatus || valueDisabled['file_2']"
                  fileAccept="image/jpeg,application/pdf"
                  @change="formDataChange('file_2')">
                </common-upload>
                3.对供水企业抄录的注册水表读数有异议的，应当提供供水企业出具的勘误证明：<common-upload
                  v-model="formData['file_3']"
                  :disabled="!editStatus || valueDisabled['file_3']"
                  fileAccept="image/jpeg,application/pdf"
                  @change="formDataChange('file_3')">
                </common-upload>
                4.对注册水表的准确度有异议的，应当自提出复核申请之日起60日内提供有流量计量器具检测资质的机构出具的水表《检定结果通知书》：<common-upload
                  v-model="formData['file_4']"
                  :disabled="!editStatus || valueDisabled['file_4']"
                  fileAccept="image/jpeg,application/pdf"
                  @change="formDataChange('file_4')">
                </common-upload>
                5.其他复核理由相关证明材料：<common-upload
                  v-model="formData['file_5']"
                  :disabled="!editStatus || valueDisabled['file_5']"
                  fileAccept="image/jpeg,application/pdf"
                  @change="formDataChange('file_5')">
                </common-upload>
              </td>
            </tr>

          </table>
          <table class="common-form-table form-table-4">
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">特别声明</td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center" colspan="1">本建议表所填内容正确无误，附件所提交的资料及证明文件真实有效，如有虚假将承担相应法律责任。</td>
            </tr>
          </table>
          <table class="common-form-table form-table-5">
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="3">以下栏目由核定部门填写</td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" rowspan="4" colspan="1">提交附件清单核查情况</td>
              <td class="column_2 td-label" colspan="1">1.供水企业开具的水量和水费清单</td>
              <td class="column_3 text-center" colspan="1">
                <el-switch
                  v-model="formData['audit_file_2']"
                  disabled
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="0"
                  size="mini"
                ></el-switch>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_2 td-label" colspan="1">2.对供水企业抄录的注册水表读数有异议的，应当提供供水企业出具的勘误证明</td>
              <td class="column_3 text-center" colspan="1">
                <el-switch
                  v-model="formData['audit_file_3']"
                  disabled
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="0"
                  size="mini"
                ></el-switch>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_2 td-label" colspan="1">3.对注册水表的准确度有异议的，应当自提出复核申请之日起60日内提供有流量计量器具检测资质的机构出具的水表《检定结果通知书》</td>
              <td class="column_3 text-center" colspan="1">
                <el-switch
                  v-model="formData['audit_file_4']"
                  disabled
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="0"
                  size="mini"
                ></el-switch>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_2 td-label" colspan="1">4.其他复核理由相关证明材料</td>
              <td class="column_3 text-center" colspan="1">
                <el-switch
                  v-model="formData['audit_file_5']"
                  disabled
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="0"
                  size="mini"
                ></el-switch>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">核定结果</td>
              <td class="column_2 text-center" colspan="2">
                <el-input
                  v-model="formData['audit_opinion']"
                  size="mini"
                  type="textarea"
                  clearable
                  disabled
                  :title="formData['audit_opinion']"
                  @input="formDataChange('audit_opinion')"
                ></el-input>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div v-if="editStatus" class="bottom-tools clearfix">
        <div class="tools-box">
          <div class="tools-item">
            <el-button @click="cancleCancle" size="mini">取消</el-button>
          </div>
          <div class="tools-item">
            <el-button @click="confirmClick" type="success" size="mini">提交</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  A_PUL_SingleQuery,
  A_URL_Edit,
  A_URL_SingleQuery
} from '@/assets/js/axiosPresets.js'
import { F_getOptionLabel } from '@/assets/js/publicFunSet.js'
import selectWaterNature from '@/components/util/selectWaterNature'
import commonUpload from '@/components/public/commonUpload'
export default {
  components: {
    selectWaterNature,
    commonUpload
  },
  props: {
    recordId: Number,
    billData: Object,
    editStatus: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  data () {
    return {
      dictKeyList: [
        'UsewaterRecheckReason'
      ],
      pageLoading: false,
      formData: {},
      valueDisabled: {
        code: true
      }
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.userInfo
    },
    dictLabelValues () {
      return this.$store.state.dictLabelValues
    },
    billName () {
      return new Date(this.billData.s_date).format('yyyy年M月') + ' - ' + new Date(this.billData.e_date).format('yyyy年M月')
    }
  },
  methods: {
    F_getOptionLabel,
    async initData () {
      this.pageLoading = true
      await this.$store.dispatch('getDictLabelValues', this.dictKeyList)
      this.pageLoading = false
      this.getRecheckInfo()
    },
    async getRecheckInfo () {
      await this.getUserInfo()
    },
    async getUserInfo () {
      this.pageLoading = true
      const res = await this.$F_checkAxiosIn(A_PUL_SingleQuery(this.currentUser.oid))
      this.pageLoading = false
      if (!res) {
        return
      }
      const userDataSave = res.data.Content
      this.formData.user_id = userDataSave.oid
      this.formData.user_name = userDataSave.name
      this.formData.contact_man = userDataSave.contact_man
      this.formData.contact_phone = userDataSave.contact_phone
      this.formData.postal_code = userDataSave.postal_code
      this.formData.addr_detail = userDataSave.addr_detail
      this.formData.usewater_id = userDataSave.usewater_id
      this.formData = _.cloneDeep(this.formData)
    },
    formDataChange (key) {
      console.log(key, this.formData[key])
    },
    async confirmClick () {
      await this.$confirm('确认保存？')

      const newFormData = new FormData()
      // 文件
      if (this.formData.file_1 != null) {
        this.formData.file_1.forEach(item => {
          newFormData.append('file_1', item)
        })
      }
      if (this.formData.file_2 != null) {
        this.formData.file_2.forEach(item => {
          newFormData.append('file_2', item)
        })
      }
      if (this.formData.file_3 != null) {
        this.formData.file_3.forEach(item => {
          newFormData.append('file_3', item)
        })
      }
      if (this.formData.file_4 != null) {
        this.formData.file_4.forEach(item => {
          newFormData.append('file_4', item)
        })
      }
      if (this.formData.file_5 != null) {
        this.formData.file_5.forEach(item => {
          newFormData.append('file_5', item)
        })
      }
      // 表单
      newFormData.append('oid', 0)
      newFormData.append('bill_id', this.billData.oid)
      newFormData.append('user_id', this.currentUser.oid)
      newFormData.append('recheck_reason', this.formData.recheck_reason || '')
      newFormData.append('recheck_statement', this.formData.recheck_statement || '')
      newFormData.append('recheck_s_month', this.formData.recheck_month[0] || '')
      newFormData.append('recheck_e_month', this.formData.recheck_month[1] || '')

      this.pageLoading = true
      const res = await this.$F_checkAxiosIn(A_URL_Edit(newFormData))
      this.pageLoading = false
      if (!res) {
        return
      }
      this.$message({
        showClose: true,
        message: '操作成功！',
        type: 'success'
      })
      this.$emit('successThen')
    },
    cancleCancle () {
      this.$emit('cancle')
    }
  },
  mounted () {
    this.initData()
  }
}
</script>

<style lang="scss" scoped>
.bill-recheck {
  height: 680px;
  background-color: #efefef;
  @include flex-column;
  .user-select {
    padding: 0 6px;
    border-bottom: 2px solid $bd-color-second;
    background-color: #fff;
  }
  .add-form{
    height: 0;
    flex: 1;
    position: relative;
    @include flex-column;
    .add-body{
      height: 0;
      flex: 1;
      overflow-y: auto;
      .add-table{
        border: $bd-common;
        padding: 20px;
        background-color: #fff;
        margin: 12px auto;
        width: 1000px;
        td{
          padding: 2px 4px;
          line-height: 24px;
          box-sizing: border-box;
          vertical-align: middle;
          border: 1px solid #333;
          .el-cascader,
          .el-input {
            display: block;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .el-select,
          .el-date-editor.el-input{
            display: block;
            width: 100%;
          }
          .el-switch {
            padding: 4px 0;
          }
        }
        .cell{
          line-height: 24px;
        }
        .form-table{
          width: 100%;
          margin-bottom: 10px;
          .table-inner{
            width: 100%;
          }
          .row-border-none {
            border: 0;
          }
        }
        .text-center{
          text-align: center;
        }
        .form-table-1{
          .column_1{
            width: 280px;
          }
        }
        .form-table-2{
          .column_1{
            width: 160px;
          }
          .column_2{
            width: 200px;
          }
          .column_3{
            width: 160px;
          }
        }
        .form-table-3{
          .column_1{
            width: 160px;
          }
        }
        .form-table-5{
          .column_1{
            width: 160px;
          }
          .column_3{
            width: 160px;
          }
        }
      }
    }
    .bottom-tools{
      background-color: #fff;
      border-top: $bd-common;
      .tools-box {
        float: right;
        padding: 5px;
        .tools-item {
          display: inline-block;
          margin-left: 6px;
        }
      }
    }
  }

}
</style>